import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-dusk"]
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = {
  key: 0,
  class: "mr-3",
  "data-dusk": 'org-item'
}
const _hoisted_4 = {
  key: 0,
  class: "ml-8",
  "data-dusk": 'children-list'
}
const _hoisted_5 = {
  key: 0,
  class: "flex justify-end items-center mt-3"
}
const _hoisted_6 = { class: "flex items-center gap-4" }
const _hoisted_7 = { class: "space-y-3 mt-3 mb-8" }

import { IGroupSegment } from '@/lib';
import { BaseIcon } from '@/lib/components/Icon';
import { BaseSwitch } from '@/lib/components/Switch';
import { BaseCheckbox } from '@/lib/components/Checkbox';
import MedKitBadge from '@/lib/components/Badge/MedKitBadge.vue';

interface TreeItemProps {
  item: IGroupSegment;
  selectedItems: string[];
  disabledItems: string[];
  expandedSections: Set<string>;
  level?: number;
  hasLeafChildrenFn: (children: IGroupSegment[]) => boolean;
  getSelectAllStateFn: (children: IGroupSegment[]) => boolean | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TreeItem',
  props: {
    item: {},
    selectedItems: {},
    disabledItems: { default: () => [] },
    expandedSections: {},
    level: { default: 0 },
    hasLeafChildrenFn: {},
    getSelectAllStateFn: {}
  },
  emits: ["toggle-expanded", "toggle-selection", "toggle-select-all"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const hasChildren = (item: IGroupSegment) => item.children && item.children.length > 0;

const isExpanded = (itemId: string) => props.expandedSections.has(itemId);

const isSelected = (itemId: string) => props.selectedItems.includes(itemId);
const isDisabled = (itemId: string) => props.disabledItems.includes(itemId);

const handleToggleExpanded = (itemId: string) => {
  emit('toggle-expanded', itemId);
};

const handleToggleSelection = (itemId: string) => {
  emit('toggle-selection', itemId);
};

const handleToggleSelectAll = (children: IGroupSegment[]) => {
  emit('toggle-select-all', children);
};

return (_ctx: any,_cache: any) => {
  const _component_TreeItem = _resolveComponent("TreeItem", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      "data-dusk": hasChildren(_ctx.item) ? 'parent-item' : 'single-item',
      class: _normalizeClass(["border border-gray-300 rounded-lg shadow-sm", {
      'bg-white': _ctx.item.isActive && !(!hasChildren(_ctx.item) && isDisabled(_ctx.item.id)),
      'bg-gray-100 text-gray-500': !_ctx.item.isActive || isDisabled(_ctx.item.id),
      'bg-red-50 border-red-200': !hasChildren(_ctx.item) && isDisabled(_ctx.item.id)
    }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex items-center flex-1", {
          'px-4 py-4': hasChildren(_ctx.item),
          'py-1': !hasChildren(_ctx.item)
        }])
        }, [
          (!hasChildren(_ctx.item))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(BaseCheckbox), {
                  "model-value": isSelected(_ctx.item.id),
                  disabled: !_ctx.item.isActive || isDisabled(_ctx.item.id),
                  border: false,
                  shadow: false,
                  label: _ctx.item.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (handleToggleSelection(_ctx.item.id)))
                }, null, 8, ["model-value", "disabled", "label"])
              ]))
            : _createCommentVNode("", true),
          (hasChildren(_ctx.item))
            ? (_openBlock(), _createBlock(_unref(BaseIcon), {
                key: 1,
                name: isExpanded(_ctx.item.id) ? 'chevron-down' : 'chevron-right',
                height: "1.125rem",
                width: "1.125rem",
                class: "cursor-pointer text-gray-500 hover:text-gray-700 mr-4",
                "data-dusk": "chevron-icon",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleToggleExpanded(_ctx.item.id)))
              }, null, 8, ["name"]))
            : _createCommentVNode("", true),
          (hasChildren(_ctx.item))
            ? (_openBlock(), _createElementBlock("span", {
                key: 2,
                class: "text-base mr-4 cursor-pointer hover:text-gray-700",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (handleToggleExpanded(_ctx.item.id)))
              }, _toDisplayString(_ctx.item.name), 1))
            : _createCommentVNode("", true),
          (_ctx.item.label?.name)
            ? (_openBlock(), _createBlock(MedKitBadge, {
                key: 3,
                class: "capitalize",
                kind: _ctx.item.label.kind,
                label: _ctx.item.label.name,
                size: "small"
              }, null, 8, ["kind", "label"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "badges", {
            item: _ctx.item,
            isDisabled: isDisabled(_ctx.item.id),
            hasChildren: hasChildren(_ctx.item)
          })
        ], 2)
      ])
    ], 10, _hoisted_1),
    (hasChildren(_ctx.item) && isExpanded(_ctx.item.id))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.hasLeafChildrenFn(_ctx.item.children!))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-sm font-medium text-gray-900" }, "Select all", -1)),
                  _createVNode(_unref(BaseSwitch), {
                    "model-value": _ctx.getSelectAllStateFn(_ctx.item.children!),
                    disabled: !_ctx.item.isActive,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (handleToggleSelectAll(_ctx.item.children!)))
                  }, null, 8, ["model-value", "disabled"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.children, (child) => {
              return (_openBlock(), _createBlock(_component_TreeItem, {
                key: child.id,
                item: child,
                "selected-items": _ctx.selectedItems,
                "disabled-items": _ctx.disabledItems,
                "expanded-sections": _ctx.expandedSections,
                level: _ctx.level + 1,
                "has-leaf-children-fn": _ctx.hasLeafChildrenFn,
                "get-select-all-state-fn": _ctx.getSelectAllStateFn,
                onToggleExpanded: handleToggleExpanded,
                onToggleSelection: handleToggleSelection,
                onToggleSelectAll: handleToggleSelectAll
              }, {
                badges: _withCtx((slotProps) => [
                  _renderSlot(_ctx.$slots, "badges", _mergeProps({ ref_for: true }, slotProps))
                ]),
                _: 2
              }, 1032, ["item", "selected-items", "disabled-items", "expanded-sections", "level", "has-leaf-children-fn", "get-select-all-state-fn"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})